<template>
  <a
    class="card -small -article -m -stretch-x g-col-md-4 g-col-lg-3"
    :class="[post?.group?.length ? `-${post.group}` : '']"
    :href="post.url"
  >
    <picture class="card__background">
      <img v-if="img.length" :src="img" :alt="post.title" />
    </picture>
    <div v-if="cardTag.length" class="tags">
      <Tag variant="-outline" @click="onTagClick">{{ cardTag }}</Tag>
    </div>
    <div class="card__content">
      <div class="card__header">
        <time v-if="post.date.length" class="card__date t3" v-html="post.date" />
        <h4 class="card__title h4">{{ post.title }}</h4>
      </div>
      <div class="card__intro t1" v-html="post.description" />
    </div>
  </a>
</template>

<script setup lang="ts">
  import { computed } from '#imports';
  import { Tag } from '@nuxt-shared/ui/tag';
  import type { CategoryFeedPost } from '../types';

  const props = defineProps<{
    post: CategoryFeedPost;
  }>();

  const emit = defineEmits<{
    (e: 'tag-click', tag: string): void;
  }>();

  const img = computed(() => props.post?.pictures?.['IMG_XS'] || '');
  const cardTag = computed(() =>
    props.post.tags && props.post.tags.length > 0 ? props.post.tags[0] : '',
  );

  const onTagClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    emit('tag-click', cardTag.value);
  };
</script>
